
class FidelityPoints extends HTMLElement {
  points;
  static URL = `${Utils.API_URL}/api/fidelity/profile`;

  connectedCallback() {
    this.init();
  }

  init = () => {
    this.getPoints();
  }

  getPoints = () => {
    axios({
      url: FidelityPoints.URL,
      withCredentials: true,
      method: 'GET',
      headers: {
        "X-Pittarello-Refresh-Token": this.dataset.token
      },
      params: {
        customer_gid: this.dataset.customer
      }
    }).then((response) => {
      this.points = response.data.data.fidelity_card[0].balance;
      this.setText();
    }).catch((error) => {
      this.setError(error);
    });
  }

  setText = () => {
    this.innerHTML = this.dataset.text.replaceAll('{balance}', this.points); 
  }

  setError = (e) => {
    this.innerHTML = this.dataset.error; 
  
    //se è 401 c'è un problema con la fidelity quindi slogghiamo anche da shopify
    if(e.status == 401) {
      location.href = '/account/logout';
    }
  }
}
if (!window.customElements.get("fidelity-points")) {
  window.customElements.define("fidelity-points", FidelityPoints);
}

class AuthForm extends HTMLElement {
  form; errors; errorsTemplate; errorsContainer; loader;

  connectedCallback() {
    this.form = this.querySelector('theme-form');
    this.errors = JSON.parse(this.querySelector('[data-errors]').innerHTML);
    this.errorsTemplate = this.querySelector('[data-errors-template]').innerHTML;
    this.errorsContainer = this.querySelector('[data-errors-container]');
    this.loader = document.querySelector('theme-loader[data-global]');
    this.init();
  }

  init = () => {
    this.form.addEventListener(Utils.E_FORM_SUBMIT, () => this.openLoader());
    this.form.addEventListener(Utils.E_FORM_SUCCESS, (e) => this.checkSubmit(e.detail));
    this.form.addEventListener(Utils.E_FORM_ERROR, (e) => this.error(e.detail.response.status));
    this.form.addEventListener(Utils.E_FORM_SENT, () => this.closeLoader());
  }

  checkSubmit = (data) => {
    if(data.success) {
      this.success(data);
    } else {
      this.error(data.error);
    }
  }

  success = (data) => {
    console.log(data);
  }

  error = (error) => {
    if(error.errorCode != undefined)
      error = error.errorCode;
    const msg = this.errors[error];
    console.log(error, this.errors, msg);
    if(this.errorsContainer != undefined && msg != undefined) {
      this.errorsContainer.innerHTML = this.errorsTemplate.replaceAll('${errorText}', msg);
    } else {
      Utils.errorHandler({
        message: msg,
        target: 'auth-form',
        error: error,
        type: 'fidelity',
        popup: true
      });
    }
  }

  openLoader = () => {
    this.loader.show();
  }

  closeLoader = () => {
    this.loader.hide();
  }
}

class MainLogin extends AuthForm {

  init = () => { 
    this.form.addEventListener(Utils.E_FORM_SUBMIT, () => this.openLoader());
    this.form.addEventListener(Utils.E_FORM_SUCCESS, (e) => this.checkSubmit(e.detail));
    this.form.addEventListener(Utils.E_FORM_ERROR, (e) => this.error(e.detail.response.status));
    this.form.addEventListener(Utils.E_FORM_SENT, () => this.closeLoader());
    const red = this.form.form.redirect_url;
    if(red != undefined) {
      const params = new URLSearchParams(window.location.search);
      if(params.get('checkout_url') != null) {
        red.value = params.get('checkout_url');
      }
    }
  }

  success = (data) => {
    Shopify.analytics.publish(Utils.E_LOGIN, {formData: data});
    location.href = data.redirect_url;
  }
}
if (!window.customElements.get("main-login")) {
  window.customElements.define("main-login", MainLogin);
}

class MainRecovery extends AuthForm {
  body;

  connectedCallback() {
    super.connectedCallback();
    this.body = this.querySelector('[data-body]');
  }

  success = (data) => {
    this.body.innerHTML = this.dataset.success;
  }
}
if (!window.customElements.get("main-recovery")) {
  window.customElements.define("main-recovery", MainRecovery);
}

class MainRegister extends AuthForm {

  success = (data) => {
    Shopify.analytics.publish(Utils.E_SIGNUP, {formData: data});
    Swal.fire({
      title: this.errors.success_title,
      text: this.errors.success_text,
      icon: 'success',
      confirmButtonText: this.errors.success_btn,
      iconColor: 'var(--bs-success)',
      color: 'var(--bs-body-color)',
      background: 'var(--bs-body-bg)',
      customClass: {
        title: 'fs-5',
        confirmButton: 'btn btn-primary',
        container: 'fs-body',
        htmlContainer: 'fs-body'
      }
    }).then(() => {
      location.href = this.dataset.redirect;
    });
  }
}
if (!window.customElements.get("main-register")) {
  window.customElements.define("main-register", MainRegister);
}

class AccountFamily extends HTMLElement {
  button; template; container;

  connectedCallback() {
    this.button = this.querySelector('[data-add]');
    this.template = this.querySelector('[data-template]').innerHTML;
    this.container = this.querySelector('[data-container]');
    this.init();
  }

  init = () => {
    this.button.addEventListener('click', () => this.addForm());
  }

  addForm = (member=null) => {
    const template = this.template.replaceAll('{number}', this.container.children.length+1)
                                  .replaceAll('{index}', this.container.children.length);
    this.container.insertAdjacentHTML('beforeend', template);
    this.container.querySelectorAll('[data-remove]').forEach(element => {
      element.addEventListener('click', (e) => this.removeForm(e));
    });
    if(member != null) {
      const block = Array.from(this.container.querySelectorAll('[data-block]')).at(this.container.children.length-1);
      if(block){
        const gender = block.querySelector(`[name="${AccountData.MEMBER_GENDER}"][value="${member.sex}"]`);
        if (gender)
          gender.checked = true;
        block.querySelector(`[name="${AccountData.MEMBER_BIRTHDAY}"]`).value = new Date(member.birthDay).toISOString().split('T')[0];
        block.querySelector(`[name="${AccountData.MEMBER_ROLE}"]`).value = member.type;
      }
    }
  }

  getData = () => {
    const blocks = Array.from(this.container.querySelectorAll('[data-block]'));
    return blocks.map(block => {
      const genders = Array.from(block.querySelectorAll(`[name="${AccountData.MEMBER_GENDER}"]`)).filter(element => element.checked).map(element => element.value);
      const birthDay = block.querySelector(`[name="${AccountData.MEMBER_BIRTHDAY}"]`).value;
      return {
        "type": block.querySelector(`[name="${AccountData.MEMBER_ROLE}"]`).value,
        "birthDay": birthDay.length > 0 ? birthDay : null,
        "sex": genders.length > 0 ? genders[0] : null
      }
    });
  }

  removeForm = (e) => {
    e.preventDefault();
    e.target.closest('[data-block]').remove();
  }
}
if (!window.customElements.get("account-family")) {
  window.customElements.define("account-family", AccountFamily);
}

class AccountData extends HTMLElement {
  form; family; profile; themeForm; token; loader; shops = [];
  static URL = `${Utils.API_URL}/api/fidelity/profile`;
  static URL_SHOPS = `${Utils.API_URL}/api/fidelity/shops`;

  static GENDER = 'gender';
  static NAME = 'name';
  static SURNAME = 'surname';
  static BIRTHDAY = 'birthday';
  static ZIP = 'zip';
  static PHONE = 'phone';
  static COUNTRY = 'country';
  static SHOP = 'shop';
  static CATEGORIES = 'categories';
  static MEMBERS = 'members';
  static MEMBER_ROLE = 'member_role';
  static MEMBER_GENDER = 'member_gender';
  static MEMBER_BIRTHDAY = 'member_birthday';
  static NEWSLETTER = 'newsletter';
  static MARKETING = 'marketing';
  static PROFILATION = 'profilation';

  connectedCallback() {
    this.themeForm = this.querySelector('theme-form');
    this.form = this.themeForm.form;
    this.family = this.querySelector('account-family');
    this.token = this.dataset.token;
    this.loader = this.querySelector('theme-loader');
    this.init();
  }

  init = () => {
    this.getProfile();
    this.themeForm.addEventListener(Utils.E_FORM_SUBMIT, () => this.submitForm());
  }

  getData = () => {
    const data = new FormData(this.form);
    const obj = {
      "name": this.checkValue(data.get(AccountData.NAME)),
      "surname": this.checkValue(data.get(AccountData.SURNAME)),
      "capCode": this.checkValue(data.get(AccountData.ZIP)),
      "phone": this.checkValue(data.get(AccountData.PHONE)),
      "gender": this.checkValue(data.get(AccountData.GENDER)),
      "birthDay": data.get(AccountData.BIRTHDAY).length > 0 ? data.get(AccountData.BIRTHDAY) : null,
      "country": this.checkValue(data.get(AccountData.COUNTRY)),
      "language": Shopify.locale,
      "favouriteCategoriesOfProducts": Array.from(this.querySelectorAll(`[name="${AccountData.CATEGORIES}"]`)).filter(element => element.checked).map(element => element.value),
      "favouriteShop": {
        "id": this.checkValue(data.get(AccountData.SHOP))
      },
      "numberOfFamilyMembers": data.get(AccountData.MEMBERS) ? parseInt(data.get(AccountData.MEMBERS)) : null,
      "familyMembers": this.family.getData(),
      "personalDataUseForMarketingPurposesAuthorization": data.get(AccountData.MARKETING) != null,
      "personalDataUseForProfilationPurposesAuthorization": data.get(AccountData.PROFILATION) != null,
      "newsLetterRegistration": data.get(AccountData.NEWSLETTER) != null
    };
    return obj;
  }

  checkValue = (value) => {
    return value && value.length > 0 ? value : null;
  }

  submitForm = () => {
    this.openLoader();
    const data = this.getData();
    axios({
      url: this.form.action,
      method: 'put',
      withCredentials: true,
      data: data,
      headers: {
        "X-Pittarello-Refresh-Token": this.token
      },
      params: {
        customer_gid: this.dataset.customer
      }
    })
    .then(response => {
      this.token = response.headers.get('x-pittarello-refresh-token');
      Swal.fire({
        title: this.dataset.successTitle,
        text: this.dataset.successText,
        icon: 'success',
        iconColor: 'var(--bs-success)',
        color: 'var(--bs-body-color)',
        background: 'var(--bs-body-bg)',
        customClass: {
          title: 'fs-5',
          confirmButton: 'btn btn-primary',
          container: 'fs-body',
          htmlContainer: 'fs-body'
        }
      });
    })
    .catch(error => {
      Utils.errorHandler({
        message: error.response.data.message || error.message,
        target: 'account-data',
        error: error,
        type: 'fidelity',
        popup: true
      });
    })
    .finally(() => {
      this.closeLoader();
    });
  }

  getProfile = () => {
    axios({
      url: AccountData.URL,
      method: 'GET',
      withCredentials: true,
      headers: {
        "X-Pittarello-Refresh-Token": this.token
      },
      params: {
        customer_gid: this.dataset.customer
      }
    }).then((response) => {
      this.profile = response.data.data;
      this.token = response.headers.get('x-pittarello-refresh-token');
      this.getShops();
      this.getData();
    }).catch((error) => {
      this.closeLoader();
      
      //se è 401 c'è un problema con la fidelity quindi slogghiamo anche da shopify
      if(error.status == 401) {
        location.href = '/account/logout';
      }
    });
  }

  getShops = () => {
    axios({
      url: AccountData.URL_SHOPS,
      method: 'GET',
      withCredentials: true
    }).then((response) => {
      this.shops = response.data;
      this.setData();
    }).catch((error) => {
      console.log(error);
    }).finally(() => {
      this.closeLoader();
    });
  }

  setData = () => {
    this.shops.forEach(shop => {
      if(shop.shop_id != undefined) {
        const option = document.createElement('option');
        option.value = shop.shop_id.value;
        option.text = shop.name;
        this.form['shop'].appendChild(option);
      }
    });
    this.setValue(AccountData.GENDER, this.profile.gender);
    this.setValue(AccountData.NAME, this.profile.firstname);
    this.setValue(AccountData.SURNAME, this.profile.lastname);
    this.setValue(AccountData.PHONE, this.profile.phone);
    this.setValue(AccountData.BIRTHDAY, this.profile.birthday.split(' ')[0]);
    this.setValue(AccountData.ZIP, this.profile.zip);
    this.setValue(AccountData.COUNTRY, this.profile.country);
    this.setValue(AccountData.SHOP, this.profile.favourite_shop_code);
    this.setValue(AccountData.CATEGORIES, this.profile.favouriteCategoriesOfProducts.split(','));
    this.setValue(AccountData.MEMBERS, this.profile.numberOfFamilyMembers);
    this.setValue(AccountData.NEWSLETTER, this.profile.auth_newsletter);
    this.setValue(AccountData.MARKETING, this.profile.auth_data_marketing);
    this.setValue(AccountData.PROFILATION, this.profile.auth_data_profilation);

    if(this.profile.favourite_shop_code){
      localStorage.setItem('favourite_shop', this.profile.favourite_shop_code);
    }
    
    this.profile.family_members.forEach((member, i) => {
      this.family.addForm(member);
    });
  }

  setValue = (name, value) => {
    if(value != undefined) {
      const input = this.form[name];
      if(input != undefined) {
        if(input.tagName == 'SELECT') {
          const options = input.querySelectorAll('option');
          options.forEach(option => {
            if(option.value == value) {
              input.value = value;
              return;
            }
          });
        } else if(input.type == 'checkbox') {
          input.checked = value;
        } else if(typeof input == 'object' && input.length > 0) {
          input.forEach(element => {
            element.checked = value.includes(element.value);
          });
        } else {
          input.value = value;
        }
      }
    } 
  }

  openLoader = () => {
    this.loader.show();
  }

  closeLoader = () => {
    this.loader.hide();
  }
  
}
if (!window.customElements.get("account-data")) {
  window.customElements.define("account-data", AccountData);
}

class MainReset extends AuthForm {
  token; expiredContainer; formContainer; formLoader;
  static PASSWORD_SET = 'PASSWORD_SET';

  connectedCallback() {
    this.expiredContainer = this.querySelector('[data-expired]');
    this.formContainer = this.querySelector('[data-form]');
    this.formLoader = this.querySelector('theme-loader:not([data-global])');
    super.connectedCallback();
    this.getToken();
  }

  getToken = () => {
    this.token = new URLSearchParams(window.location.search).get('token');
    if(this.token == null || this.token == '') {
      this.expired();
    } else {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'token';
      input.value = this.token;
      this.form.form.appendChild(input);
      this.showForm();
    }
    this.hideLoader();
  }

  expired = () => {
    this.expiredContainer.classList.remove('d-none');
    this.formContainer.classList.add('d-none');
  }

  showForm = () => {
    this.expiredContainer.classList.add('d-none');
    this.formContainer.classList.remove('d-none');
  }

  hideLoader = () => {
    if(this.formLoader != undefined)
    this.formLoader.hide();
  }
  
  openLoader = () => {
    if(this.formLoader != undefined)
    this.formLoader.show();
  }

  success = (data) => {
    if(data.data.message == MainReset.PASSWORD_SET) {
      Swal.fire({
        title: this.errors.success_title,
        text: this.errors.success_text,
        icon: 'success',
        confirmButtonText: this.errors.success_btn,
        iconColor: 'var(--bs-success)',
        color: 'var(--bs-body-color)',
        background: 'var(--bs-body-bg)',
        customClass: {
          title: 'fs-5',
          confirmButton: 'btn btn-primary',
          container: 'fs-body',
          htmlContainer: 'fs-body'
        }
      }).then(() => {
        location.href = this.dataset.redirect;
      });
    } else {
      this.error("error");
    }
    this.hideLoader();
  }
  
}
if (!window.customElements.get("main-reset")) {
  window.customElements.define("main-reset", MainReset);
}

class ActivateAccount extends HTMLElement {
  token; 
  static SUCCESS = ['alert', 'alert-success'];
  static ERROR = ['alert', 'alert-danger'];

  connectedCallback() {
    this.checkUrl();
    if(this.token != undefined)
      this.activate();
  }

  checkUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('url')) {
      this.token = urlParams.get('url').split('/');
      this.token = this.token[this.token.length-1];
    }
    else if(urlParams.get('activate')) {
      this.token = urlParams.get('activate');
    }
  }

  activate = () => {
    const url = `${window.azureUrl}/api/fidelity/confirm/${this.token}`;
    axios({
      url: url,
      method: 'POST',
      withCredentials: true
    }).then((r) => {
      this.innerHTML = this.dataset.success;
      ActivateAccount.SUCCESS.forEach(c => this.classList.add(c));
    }).catch((r) => {
      this.innerHTML = this.dataset.error;
      ActivateAccount.ERROR.forEach(c => this.classList.add(c));
    });
  }
}
if (!window.customElements.get("activate-account")) {
  window.customElements.define("activate-account", ActivateAccount);
}